module.exports = __webpack_public_path__ + "img/help.11d12407.png";